import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Container, Row, Col, Card, Button, Spinner, Alert } from 'react-bootstrap';
import apiService from '../../Common/Configurations/APIService';
import config from '../../Common/Configurations/APIConfig';
import './HolidayScreen.css'; 
import DefaultData from '../../CompanyData/DefaultData';

const DestinationPackages = () => {
    const { destinationId } = useParams();
    const [packages, setPackages] = useState([]);
    const [destinationName, setDestinationName] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!destinationId) return;

        const getPackagesByDestination = async () => {
            setIsLoading(true);
            setError(null);
            try {
                const companyId = DefaultData.DEFAULTCOMPANYID;
                const response = await apiService.getAll(`${config.GETPACKAGESBYDESTINATION}/${companyId}?destinationId=${destinationId}&type=Holiday`);
          
                if (response && response.succeeded) {
                    setPackages(response.data);
                    if (response.data && response.data.length > 0) {
                        setDestinationName(response.data[0].destinationName);
                    } else {
                        setDestinationName('the selected destination');
                    }
                } else {
                    throw new Error(response.message || 'Failed to fetch packages.');
                }
            } catch (err) {
                setError(err.message || 'An unexpected error occurred.');
            } finally {
                setIsLoading(false);
            }
        };

        getPackagesByDestination();
    }, [destinationId]); 

    const renderContent = () => {
        if (isLoading) {
            return (
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
                    <Spinner animation="border" variant="primary" />
                    <span className="ms-2">Loading Packages...</span>
                </div>
            );
        }

        if (error) {
            return <Alert variant="danger">Error: {error}</Alert>;
        }

        if (packages.length === 0) {
            return (
                <Alert variant="info" className="text-center">
                    <h4>No Packages Found</h4>
                    <p>We couldn't find any holiday packages for {destinationName}. Please check back later.</p>
                    <Button as={Link} to="/holidays" variant="primary">Explore Other Holidays</Button>
                </Alert>
            );
        }
        return (
            <Row xs={1} md={2} lg={3} className="g-4">
                {packages.map(pkg => (
                    <Col key={pkg.packageId}>
                        <Card className="package-card h-100">
                            <Card.Img variant="top" src={pkg.imageSrc} alt={pkg.packageName} />
                            <Card.Body className="d-flex flex-column">
                                <Card.Title className="fw-bold mb-1">
                                    <Link to={`/holiday-details/${pkg.packageId}`} className="card-title-link">
                                        {pkg.packageName}
                                    </Link>
                                </Card.Title>
                                <div className="icon-text mb-2 small">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6" /></svg>
                                    <span>{pkg.destinationsCover}</span>
                                </div>
                                <div className="mt-auto pt-3">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <div className="icon-text fw-medium">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" /></svg>
                                            <span>{pkg.duration}</span>
                                        </div>
                                        <span className="price-tag">{pkg.currency} {pkg.price}</span>
                                    </div>
                                    <div className="d-grid">
                                        <Button as={Link} to={`/holiday-details/${pkg.packageId}`} variant="primary">View Details</Button>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        );
    };

    return (
        <div className="destination-packages-page">
            <div className="main-content">
                <Container className="my-5 py-4">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h2 className="section-title mb-0 text-start">
                            {isLoading ? '' : `Holiday Packages in ${destinationName}`}
                        </h2>
                        <Button as={Link} to="/holidays" variant="outline-secondary">
                            ← Back to Holidays
                        </Button>
                    </div>
                    {renderContent()}
                </Container>
            </div>
        </div>
    );
};

export default DestinationPackages;